import { render, staticRenderFns } from "./sensation.vue?vue&type=template&id=dd3c1724&"
import script from "./sensation.vue?vue&type=script&lang=js&"
export * from "./sensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports